import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { isBlank } from "../../util/ext";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, DialogContentText, DialogTitle } from "@material-ui/core";
import { useErrorBox } from "./use-errorBox";
import { useDeleteOrganizationLogo } from "../organizationServices";
import PhotoOutlinedIcon from "@material-ui/icons/PhotoOutlined";

const DeleteOrganizationLogoDialog = ({
  organizationId,
  organizationLogoUrl,
  onCancel,
  onDelete,
  open,
}) => {
  const [deleting, setDeleting] = useState(false);

  const { setGeneralError, ErrorBox: DialogErrors } = useErrorBox();

  const logoDelete = useDeleteOrganizationLogo();
  const handleApply = async () => {
    setDeleting(true);
    try {
      await logoDelete.mutateAsync({
        resourceIds: {
          id: organizationId,
        },
      });
      onDelete();
    } catch (err) {
      setGeneralError(err);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="edit-organization-logo-dialog-title">
        Delete Organization Logo
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you with to delete this Organization Logo.
        </DialogContentText>
        <DialogErrors />

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          maxWidth={600}
        >
          <Box
            margin={2}
            minWidth={250}
            minHeight={150}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {deleting ? (
              <CircularProgress />
            ) : isBlank(organizationLogoUrl) ? (
              <PhotoOutlinedIcon style={{ fontSize: 60 }} />
            ) : (
              <img
                style={{ maxWidth: 250, maxHeight: 150 }}
                src={organizationLogoUrl}
                alt="Logo"
              />
            )}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button disabled={deleting} onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button disabled={deleting} onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrganizationLogoDialog;
